<!--
 * @Description: 选择估价信息头部
 * @Author: YH000027
-->
<template>
  <div :style="{ top: `${top}px`, borderRadius: `8px` }">
    <div class="pc_progress-main">
      <div v-if="current" class="progress-bar" :style="{ width: `${progressBarWidth}%` }">
        <div class="wrap-progressNum">
          <span class="progressNum">{{ current + '/' + total }}</span>
        </div>
      </div>
      <span v-else class="progressNum1">{{ current + '/' + total }}</span>
    </div>
  </div>
</template>

<script>
// import marquee from "./marquee.vue";
// import { isHasTitleInAppObliged } from '@/config/index.js';
export default {
  props: ['current', 'total', 'title'],
  components: {
    // marquee
  },
  data() {
    return {
      topTipColor: '',
      isInvite: true
    };
  },
  methods: {
    setColor(o) {
      console.log(o);
      this.topTipColor = o?.color || '';
      this.isInvite = o?.isInvite ? false : true;
    }
  },
  computed: {
    /**
     * 进度条长度
     */
    progressBarWidth() {
      return (this.current / this.total) * 100;
    },
    top() {
      // return !this.$isOpenInWebview || isHasTitleInAppObliged ? 44 : 0
      return 0;
    }
  }
};
</script>

<style lang="less" scoped>
// @import "../../../styles/reset.scss";
.pc_progress-main {
  background: #f8f8f8;
  border-radius: 8px;
  text-align: center;
  .progressNum1 {
    color: #b2b2b2;
    font-size: 12px;
  }

  .progress-bar {
    height: 16px;
    // background: linear-gradient(
    //   90deg,
    //   var(--theme-color) 0%,
    //   var(--theme-color) 100%
    // );
    // border-radius: 0 2px 2px 0;
    //background-color: #405FFF;
    background: linear-gradient(270deg, #405FFF 0%, #4070FF 100%);
    border-radius: 8px;
    //font-size: 12px;
    color: #fff;
    text-align: right;
    box-sizing: border-box;
    position: relative;
    .wrap-progressNum {
      position: absolute;
      border-radius: 8px;
      //background: linear-gradient(270deg, #405FFF 0%, #FFAA33 100%);
      top: 0px;
      right: 8px;
      font-size: 24px;
      transform-origin: 100% 0%;
      transform: scale(0.5);
      // margin-right: 8px;
    }
  }
  .tips {
    height: 22px;
    padding: 0 21px;
    font-size: 11px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // background: var(--theme-light-color);
    background: #fff5eb;
    border: 1px solid #f2f3f5;
    .total {
      // color: $gray;
    }
  }
  .tipInvite {
    height: 22px;
    padding: 0 21px;
  }
  .tips.yellow {
    background: #fbeae4;
  }
  .tips.red {
    background: #f7e4e6;
  }
  .tips .total-box {
    width: 55px;
    text-align: right;
  }
  .phone-model {
    height: 40px;
    line-height: 40px;
    padding-left: 21px;
    font-size: 14px;
    // color: $gray;
    // background: #fafafb;
    background: #fff;
    display: flex;
    justify-content: flex-start;
    .title {
      display: inline;
      // @include singleEllipsis(240px);
      // color: $black;
      font-weight: 400;
    }
    @media screen and (max-width: 320px) {
      .title {
        // @include singleEllipsis(210px);
      }
    }
  }

  h1 {
    font-size: 16px;
    margin-right: 12px;
  }
  .tag {
    width: 70px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    color: #ff592c;
    // background: $pink;
    border-radius: 5px;
  }
}
</style>
